import { FoodTypesDto } from "@gtpl/shared-models/masters";
import { Product } from "../product.entity";
import { ProductDTO } from "./product.dto";

export class ProductAdapter {
    convertDtoToEntity(dtoObj: ProductDTO,  isUpdate: boolean = false ): Product {
        try {
            const entityObj = new Product();
            entityObj.createdUser = dtoObj.createdUser;
            entityObj.productCode = dtoObj.productCode;
            entityObj.productName = dtoObj.productName;
            entityObj.hsnCode =dtoObj.hsnCode;
            entityObj.remarks = dtoObj.remarks;
        console.log(dtoObj.productId);

            if (dtoObj.productId) {
                entityObj.productId = dtoObj.productId;
                entityObj.updatedUser = dtoObj.updatedUser;
            }
            entityObj.isActive = dtoObj.isActive;
            return entityObj;
        } catch (Error) {
            throw Error;
        }
    }

    public convertEntityToDto(employeeObject: Product): ProductDTO {
        console.log(employeeObject.productId);
        const foodTypeDetailsDTO= new ProductDTO;
        foodTypeDetailsDTO.productId = employeeObject.productId;
        foodTypeDetailsDTO.productCode = employeeObject.productCode;
        foodTypeDetailsDTO.productName = employeeObject.productName;
        foodTypeDetailsDTO.hsnCode=employeeObject.hsnCode;
        foodTypeDetailsDTO.remarks = employeeObject.remarks;
        foodTypeDetailsDTO.isActive = employeeObject.isActive;
        foodTypeDetailsDTO.createdAt = employeeObject.createdAt;
        foodTypeDetailsDTO.updatedAt = employeeObject.updatedAt;
        foodTypeDetailsDTO.createdUser = employeeObject.createdUser;
        foodTypeDetailsDTO.updatedUser = employeeObject.updatedUser;
        foodTypeDetailsDTO.versionFlag = employeeObject.versionFlag;
        return foodTypeDetailsDTO;
      }
}